<template>
  <b-row class="margin-0 width-percent-100">
    <b-col cols="12" class="padding-0 flex-between" >
      <Input
        ref="inputReference"
        :value="value"
        :name="name"
        :title="title"
        :label="label"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :vuelidateObj="vuelidateObj"
        :minLength="minLength"
        :maxLength="maxLength"
        :hasLeftIcon="hasLeftIcon"
        :isPasswordChecker="isPasswordChecker"
        :rowClass="rowClass"
        :rightIcon="rightIcon"
        :autocomplete="autocomplete"
        :autoFocus="autoFocus"
        :hasEraseIcon="hasEraseIcon"
        :infoTooltip="infoTooltip"
        :isPasswordTogglerIcon="isPasswordTogglerIcon"
        :loading="loading"
        @input="input"
        @focus="focus"
        @blur="blur"
      />
      <Button
        variant="outline-primary"
        :text="$lang.randomPassword"
        class="margin-top-32 margin-right-8"
        contentClass="justify-content-center"
        @click="createRandomPassword"
      />
    </b-col>
  </b-row>
</template>

<script>
import { Input, Button } from "@/components/re-design/forms";
import { generateRandomPassword } from "@/shared/utils";
import { ref, toRefs } from "vue";
export default {
  components: { Input, Button },
  props: {
    value: {}, // watch model
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "عنوان",
    },
    id: {
      type: String,
      default: "default-id",
    },
    type: {
      type: String,
      default: "password",
    },
    placeholder: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vuelidateObj: {
      type: Object,
      default: null,
    },
    minLength: {
      type: [String, Number],
      default: 1,
    },
    maxLength: {
      type: [String, Number],
      default: 32,
    },
    hasLeftIcon: {
      type: Boolean,
      default: false,
    },
    isPasswordChecker: {
      type: Boolean,
      default: true,
    },
    rowClass: {
      type: String,
      default: "margin-bottom-22",
    },
    rightIcon: {
      type: String,
      default: null,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    hasEraseIcon: {
      type: Boolean,
      default: false,
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    isPasswordTogglerIcon: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasPasswordWithSymbol: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { name, hasPasswordWithSymbol } = toRefs(props);

    const input = (key, value) => {
      emit("input", key, value);
    };
    const focus = (key) => {
      emit("focus", key);
    };
    const blur = (key, value) => {
      emit("blur", key, value);
    };
    const inputReference = ref(null);
    const createRandomPassword = () => {
      const randomPassword = generateRandomPassword(
        10,
        hasPasswordWithSymbol.value
      );
      input(name.value, randomPassword);
      inputReference.value.checkPassword(randomPassword);
    };

    // return data to be used in template
    return {
      name,
      hasPasswordWithSymbol,
      inputReference,
      input,
      focus,
      blur,
      createRandomPassword,
    };
  },
};
</script>
